/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  NotFoundErrorResult,
  ResultOfAssetManagersViewModel,
  ResultOfBeneficiariesViewModel,
  ResultOfBookSummaryViewModel,
  ResultOfClientBankAccountsViewModel,
  ResultOfClientPersonalDetailsViewModel,
  ResultOfEffectiveAnnualCost,
  ResultOfEventsViewModel,
  ResultOfIntermediaryToDoListViewModel,
  ResultOfLatestTransactionsViewModel,
  ResultOfListOfSection14ClientRenewalModel,
  ResultOfOutstandingSection14FeeRenegotiations,
  ResultOfPortfolioSummaryViewModel,
  ResultOfTopFundsViewModel,
  ResultOfTransactionDetailViewModel,
  ResultOfTransactionSummaryReportViewModel,
  ResultOfTransactionSummaryViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultOfAssetManagersViewModelFromJSON,
    ResultOfAssetManagersViewModelToJSON,
    ResultOfBeneficiariesViewModelFromJSON,
    ResultOfBeneficiariesViewModelToJSON,
    ResultOfBookSummaryViewModelFromJSON,
    ResultOfBookSummaryViewModelToJSON,
    ResultOfClientBankAccountsViewModelFromJSON,
    ResultOfClientBankAccountsViewModelToJSON,
    ResultOfClientPersonalDetailsViewModelFromJSON,
    ResultOfClientPersonalDetailsViewModelToJSON,
    ResultOfEffectiveAnnualCostFromJSON,
    ResultOfEffectiveAnnualCostToJSON,
    ResultOfEventsViewModelFromJSON,
    ResultOfEventsViewModelToJSON,
    ResultOfIntermediaryToDoListViewModelFromJSON,
    ResultOfIntermediaryToDoListViewModelToJSON,
    ResultOfLatestTransactionsViewModelFromJSON,
    ResultOfLatestTransactionsViewModelToJSON,
    ResultOfListOfSection14ClientRenewalModelFromJSON,
    ResultOfListOfSection14ClientRenewalModelToJSON,
    ResultOfOutstandingSection14FeeRenegotiationsFromJSON,
    ResultOfOutstandingSection14FeeRenegotiationsToJSON,
    ResultOfPortfolioSummaryViewModelFromJSON,
    ResultOfPortfolioSummaryViewModelToJSON,
    ResultOfTopFundsViewModelFromJSON,
    ResultOfTopFundsViewModelToJSON,
    ResultOfTransactionDetailViewModelFromJSON,
    ResultOfTransactionDetailViewModelToJSON,
    ResultOfTransactionSummaryReportViewModelFromJSON,
    ResultOfTransactionSummaryReportViewModelToJSON,
    ResultOfTransactionSummaryViewModelFromJSON,
    ResultOfTransactionSummaryViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface ReportingGetBeneficiariesRequest {
    clientId?: number;
}

export interface ReportingGetBookSummaryRequest {
    intermediaryId?: number;
}

export interface ReportingGetClientBankAccountsRequest {
    clientId?: number;
}

export interface ReportingGetClientPersonalDetailsRequest {
    clientId?: number;
}

export interface ReportingGetEventsRequest {
    clientId?: number;
}

export interface ReportingGetLatestTransactionsRequest {
    clientId?: number;
}

export interface ReportingGetPortfolioSummaryRequest {
    clientId?: number;
}

export interface ReportingGetTopFundsRequest {
    clientId?: number;
}

export interface ReportingGetTransactionDetailDownloadRequest {
    clientId?: number;
    startDate?: Date;
    endDate?: Date;
    planNumber?: string | null;
}

export interface ReportingGetTransactionSummaryDownloadRequest {
    clientId?: number;
    includeIRR?: boolean;
    startDate?: Date;
    endDate?: Date;
    planNumbers?: Array<string> | null;
}

export interface ReportingGetTransactionSummaryReportRequest {
    clientId?: number;
    planNumbers?: Array<string> | null;
    startDate?: Date;
    endDate?: Date;
}

/**
 * 
 */
export class ReportingApi extends runtime.BaseAPI {

    /**
     * Get asset managers
     */
    async reportingGetAssetManagersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfAssetManagersViewModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/asset-managers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfAssetManagersViewModelFromJSON(jsonValue));
    }

    /**
     * Get asset managers
     */
    async reportingGetAssetManagers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfAssetManagersViewModel> {
        const response = await this.reportingGetAssetManagersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get Beneficiaries
     */
    async reportingGetBeneficiariesRaw(requestParameters: ReportingGetBeneficiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfBeneficiariesViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/beneficiaries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfBeneficiariesViewModelFromJSON(jsonValue));
    }

    /**
     * Get Beneficiaries
     */
    async reportingGetBeneficiaries(requestParameters: ReportingGetBeneficiariesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfBeneficiariesViewModel> {
        const response = await this.reportingGetBeneficiariesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get book summary for an intermediary.
     */
    async reportingGetBookSummaryRaw(requestParameters: ReportingGetBookSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfBookSummaryViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.intermediaryId !== undefined) {
            queryParameters['intermediaryId'] = requestParameters.intermediaryId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/book-summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfBookSummaryViewModelFromJSON(jsonValue));
    }

    /**
     * Get book summary for an intermediary.
     */
    async reportingGetBookSummary(requestParameters: ReportingGetBookSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfBookSummaryViewModel> {
        const response = await this.reportingGetBookSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Download Case History xlsx file
     */
    async reportingGetCaseHistoryDownloadRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/case-instruction-download`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download Case History xlsx file
     */
    async reportingGetCaseHistoryDownload(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.reportingGetCaseHistoryDownloadRaw(initOverrides);
        return await response.value();
    }

    /**
     * Download a Case List xlsx file
     */
    async reportingGetCaseListDownloadRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/case-list-download`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download a Case List xlsx file
     */
    async reportingGetCaseListDownload(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.reportingGetCaseListDownloadRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get list of bank accounts for client
     */
    async reportingGetClientBankAccountsRaw(requestParameters: ReportingGetClientBankAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfClientBankAccountsViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/bank-accounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfClientBankAccountsViewModelFromJSON(jsonValue));
    }

    /**
     * Get list of bank accounts for client
     */
    async reportingGetClientBankAccounts(requestParameters: ReportingGetClientBankAccountsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfClientBankAccountsViewModel> {
        const response = await this.reportingGetClientBankAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get book summary for an intermediary.
     */
    async reportingGetClientPersonalDetailsRaw(requestParameters: ReportingGetClientPersonalDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfClientPersonalDetailsViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/client-personal-details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfClientPersonalDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Get book summary for an intermediary.
     */
    async reportingGetClientPersonalDetails(requestParameters: ReportingGetClientPersonalDetailsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfClientPersonalDetailsViewModel> {
        const response = await this.reportingGetClientPersonalDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the effective annual cost
     */
    async reportingGetEffectiveAnnualCostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfEffectiveAnnualCost>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/effective-annual-cost`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfEffectiveAnnualCostFromJSON(jsonValue));
    }

    /**
     * Get the effective annual cost
     */
    async reportingGetEffectiveAnnualCost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfEffectiveAnnualCost> {
        const response = await this.reportingGetEffectiveAnnualCostRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get calendar events.
     */
    async reportingGetEventsRaw(requestParameters: ReportingGetEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfEventsViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/events`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfEventsViewModelFromJSON(jsonValue));
    }

    /**
     * Get calendar events.
     */
    async reportingGetEvents(requestParameters: ReportingGetEventsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfEventsViewModel> {
        const response = await this.reportingGetEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a quick view of an intermediary\'s most pressing to-do items
     */
    async reportingGetIntermediaryToDoListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfIntermediaryToDoListViewModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/intermediary-to-do-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfIntermediaryToDoListViewModelFromJSON(jsonValue));
    }

    /**
     * Get a quick view of an intermediary\'s most pressing to-do items
     */
    async reportingGetIntermediaryToDoList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfIntermediaryToDoListViewModel> {
        const response = await this.reportingGetIntermediaryToDoListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the summary of the client\'s latest transactions
     */
    async reportingGetLatestTransactionsRaw(requestParameters: ReportingGetLatestTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfLatestTransactionsViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/latest-transactions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfLatestTransactionsViewModelFromJSON(jsonValue));
    }

    /**
     * Get the summary of the client\'s latest transactions
     */
    async reportingGetLatestTransactions(requestParameters: ReportingGetLatestTransactionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfLatestTransactionsViewModel> {
        const response = await this.reportingGetLatestTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get section fee 14 renegotiation
     */
    async reportingGetOutstandingSection14FeeRenegotiationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfOutstandingSection14FeeRenegotiations>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/section-14-fee-renegotiations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfOutstandingSection14FeeRenegotiationsFromJSON(jsonValue));
    }

    /**
     * Get section fee 14 renegotiation
     */
    async reportingGetOutstandingSection14FeeRenegotiations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfOutstandingSection14FeeRenegotiations> {
        const response = await this.reportingGetOutstandingSection14FeeRenegotiationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a clients portfolio summary
     */
    async reportingGetPortfolioSummaryRaw(requestParameters: ReportingGetPortfolioSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfPortfolioSummaryViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/portfolio-summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfPortfolioSummaryViewModelFromJSON(jsonValue));
    }

    /**
     * Get a clients portfolio summary
     */
    async reportingGetPortfolioSummary(requestParameters: ReportingGetPortfolioSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfPortfolioSummaryViewModel> {
        const response = await this.reportingGetPortfolioSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get section fee 14 client renewals
     */
    async reportingGetSection14ClientRenewalRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfSection14ClientRenewalModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/section-14-client-renewal`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfSection14ClientRenewalModelFromJSON(jsonValue));
    }

    /**
     * Get section fee 14 client renewals
     */
    async reportingGetSection14ClientRenewal(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfSection14ClientRenewalModel> {
        const response = await this.reportingGetSection14ClientRenewalRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get Top Funds
     */
    async reportingGetTopFundsRaw(requestParameters: ReportingGetTopFundsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfTopFundsViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/top-funds`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfTopFundsViewModelFromJSON(jsonValue));
    }

    /**
     * Get Top Funds
     */
    async reportingGetTopFunds(requestParameters: ReportingGetTopFundsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfTopFundsViewModel> {
        const response = await this.reportingGetTopFundsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the details of the client\'s transactions
     */
    async reportingGetTransactionDetailRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfTransactionDetailViewModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/transaction-detail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfTransactionDetailViewModelFromJSON(jsonValue));
    }

    /**
     * Get the details of the client\'s transactions
     */
    async reportingGetTransactionDetail(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfTransactionDetailViewModel> {
        const response = await this.reportingGetTransactionDetailRaw(initOverrides);
        return await response.value();
    }

    /**
     * Download a xlsx file containing the transaction detail for a period
     */
    async reportingGetTransactionDetailDownloadRaw(requestParameters: ReportingGetTransactionDetailDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = (requestParameters.endDate as any).toISOString();
        }

        if (requestParameters.planNumber !== undefined) {
            queryParameters['planNumber'] = requestParameters.planNumber;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/transaction-detail-download`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download a xlsx file containing the transaction detail for a period
     */
    async reportingGetTransactionDetailDownload(requestParameters: ReportingGetTransactionDetailDownloadRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.reportingGetTransactionDetailDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the summary of the client\'s transactions
     */
    async reportingGetTransactionSummaryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfTransactionSummaryViewModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/transaction-summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfTransactionSummaryViewModelFromJSON(jsonValue));
    }

    /**
     * Get the summary of the client\'s transactions
     */
    async reportingGetTransactionSummary(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfTransactionSummaryViewModel> {
        const response = await this.reportingGetTransactionSummaryRaw(initOverrides);
        return await response.value();
    }

    /**
     * Download a xlsx file containing the transaction summary for a period
     */
    async reportingGetTransactionSummaryDownloadRaw(requestParameters: ReportingGetTransactionSummaryDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        if (requestParameters.includeIRR !== undefined) {
            queryParameters['includeIRR'] = requestParameters.includeIRR;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = (requestParameters.endDate as any).toISOString();
        }

        if (requestParameters.planNumbers) {
            queryParameters['planNumbers'] = requestParameters.planNumbers;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/transaction-summary-download`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download a xlsx file containing the transaction summary for a period
     */
    async reportingGetTransactionSummaryDownload(requestParameters: ReportingGetTransactionSummaryDownloadRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.reportingGetTransactionSummaryDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the summary of a client\'s transactions
     */
    async reportingGetTransactionSummaryReportRaw(requestParameters: ReportingGetTransactionSummaryReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfTransactionSummaryReportViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        if (requestParameters.planNumbers) {
            queryParameters['planNumbers'] = requestParameters.planNumbers;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = (requestParameters.endDate as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/reporting/transaction-summary-report`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfTransactionSummaryReportViewModelFromJSON(jsonValue));
    }

    /**
     * Get the summary of a client\'s transactions
     */
    async reportingGetTransactionSummaryReport(requestParameters: ReportingGetTransactionSummaryReportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfTransactionSummaryReportViewModel> {
        const response = await this.reportingGetTransactionSummaryReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
